import React, { useState } from "react";
import { customerDetails } from "Stores/customerDetails";
import Button from "Components/common/Button";
import Modal from "Components/common/Modal";
import makeApi, { URLS } from "Utils/apiURL";
import Utils from "Utils/utils";
import { toasterState } from "Components/common/Toaster";

const CancelSubscriptionPlan = (props) => {
  const { subscriptionsData = "", email = "" } = props;

  const { id: teamSubscriptionId = "" } =
    (subscriptionsData?.length && subscriptionsData[0]) || "";
  const [subscriptionData, setSubscriptionData] = useState(subscriptionsData);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggleLoaderFlag = (subid, flag) => {
    if (subid && subscriptionData) {
      subscriptionData.forEach((value) => {
        if (value && value.id && value.id === subid) {
          value.planStatusLoader = flag;
        } else if (subid === null) {
          value.planStatusLoader = flag;
        }
      });
      setSubscriptionData(Utils.removeReferenceFromObject(subscriptionData));
    }
  };

  const showCancelResultToast = (removeConnectedAccounts, respData) => {
    if (!removeConnectedAccounts) {
      toasterState.setToastMsg("Subscription cancelled successfully", "success");
      return;
    }
    if (respData?.accountsRemovalComplete) {
      toasterState.setToastMsg(
        "Subscription cancelled and all connected accounts removed successfully.",
        "success"
      );
    } else {
      const failed = respData?.connectedAccountsFailed || 0;
      const total = (respData?.connectedAccountsRemoved || 0) + failed;
      toasterState.setToastMsg(
        `Subscription cancelled. ${failed} of ${total} connected accounts couldn't be removed and will be retried.`,
        "warning"
      );
    }
  };

  const cancelSubscriptionCbk = async (removeConnectedAccounts) => {
    try {
      const config = {
        url: URLS.cancelSubscription,
        method: "POST",
        data: { email, removeConnectedAccounts },
      };
      setLoading(true);
      toggleLoaderFlag(teamSubscriptionId, true);
      let response = await makeApi(config);
      if (response?.data) {
        const respData = response.data;
        setLoading(false);
        setShowModal(false);
        if (respData.success) {
          customerDetails.getCustomerDetails(customerDetails.customerEmail);
          showCancelResultToast(removeConnectedAccounts, respData);
        } else {
          toggleLoaderFlag(teamSubscriptionId, false);
          toasterState.setToastMsg("Something went wrong", "failure");
        }
      } else {
        Utils.showApiFailureResponse(response);
        setLoading(false);
        toggleLoaderFlag(teamSubscriptionId, false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Cancel Subscription error ", error);
    }
  };

  const closeModal = () => {
    if (!loading) {
      setShowModal(false);
    }
  };

  const modalFooter = loading ? (
    <span className="cancelSubscriptionLoadMsg">
      Cancelling subscription. Please wait...
    </span>
  ) : (
    <>
      <Button
        id="deleteAccountsAndCancel"
        name="deleteAccountsAndCancel"
        type="button"
        className="modalActionBtn modalActionBtn--danger"
        btnText="Delete connected accounts & Cancel Subscription"
        icon={false}
        loader={false}
        click={() => cancelSubscriptionCbk(true)}
      />
      <Button
        id="onlyCancelSubscription"
        name="onlyCancelSubscription"
        type="button"
        className="modalActionBtn modalActionBtn--primary"
        btnText="Only Cancel Subscription"
        icon={false}
        loader={false}
        click={() => cancelSubscriptionCbk(false)}
      />
      <Button
        id="keepSubscription"
        name="keepSubscription"
        type="button"
        className="modalActionBtn modalActionBtn--ghost"
        btnText="Keep Subscription"
        icon={false}
        loader={false}
        click={closeModal}
      />
    </>
  );

  return (
    <>
      <Button
        id="cancelSubscription"
        name="cancelSubscription"
        type="button"
        className="primaryButton cancelSubscriptionButton"
        btnText="Cancel Subscription"
        icon={false}
        loader={false}
        click={() => setShowModal(true)}
      />
      {showModal && (
        <Modal
          title="Cancel Subscription"
          className="cancelSubscriptionModal"
          onClose={closeModal}
          disableClose={loading}
          footer={modalFooter}
        >
          <div className="cancelSubscriptionModalMessage">
            Remove all connected Email and LinkedIn accounts while cancelling
            this subscription?
          </div>
        </Modal>
      )}
    </>
  );
};

export { CancelSubscriptionPlan };
export default CancelSubscriptionPlan;
